import type { ApiCorpCode, UiCorpCode } from '../../schemas/corpCodes.schema';

/**
 * Maps a corp code from Api to match the UI schema.
 */
export function mapCorpCodeFromApi(apiCorpCode: ApiCorpCode): UiCorpCode {
  return {
    id: apiCorpCode?.id ?? '',
    code: apiCorpCode?.code ?? '',
    createdAt: apiCorpCode?.createdAt ?? '',
    isUsed: apiCorpCode?.isUsed ?? false,
    usedAt: apiCorpCode?.usedAt ?? null,
    usedByName: apiCorpCode?.usedBy?.name ?? null,
  };
}
